/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClusterInformationDto } from '../models/ClusterInformationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ObservabilityControllerService {

    /**
     * @returns ClusterInformationDto OK
     * @throws ApiError
     */
    public static getCluster(): CancelablePromise<ClusterInformationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/observability/cluster',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

}
